import { useState } from 'react';
import { Button, Form, Tab, Tabs } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Loader from '../components/common/Loader';
import style from '../components/UserManagement/style.module.scss';
import UserDetails from '../components/UserManagement/UserDetails';
import UserTransferHistory from '../components/UserManagement/UserTransferHistory';
import useAPI from '../hooks/useAPI';

export default function UserDetailsPage() {
  const [activeTab, setActiveTab] = useState('details');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');

  const { data, isLoading } = useAPI({
    url: `/auth/user/get/${id}`,
    method: 'GET',
    dependencies: [id],
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
  });

  return (
    <>
      <div
        className="mb-2 d-flex justify-content-between align-items-center"
        style={{ maxWidth: '81vw' }}
      >
        <div>
          <h2 className="fw-bold">
            {data?.result?.data?.firstName} {data?.result?.data?.lastName}
          </h2>
        </div>

        <div className="d-flex justify-content-center">
          <div className="d-flex gap-2 align-items-center">
            <Form.Group>
              <Button
                variant="outline-secondary border-2 rounded-2 text-dark bg-white fw-bold"
                onClick={() => navigate('/user-management')}
              >
                Back
              </Button>
            </Form.Group>
          </div>
        </div>
      </div>

      <div className="bg-white py-3 rounded-3 px-4">
        <Tabs
          id="transfer-token-tabs"
          activeKey={activeTab}
          onSelect={k => setActiveTab(k!)}
          className={`ks-tabs`}
        >
          <Tab eventKey="details" title="Details">
            {isLoading ? (
              <Loader containerClassName={style.customLoader} />
            ) : (
              <UserDetails data={data?.result?.data} />
            )}
          </Tab>
          <Tab eventKey="transfer-history" title="Transfer History">
            <UserTransferHistory />
          </Tab>
        </Tabs>
      </div>
    </>
  );
}
